module.exports = "<ion-view\r\n  title=\"{{::('navigation.header.title' | translate)}}\"\r\n  hide-nav-bar=\"true\"\r\n>\r\n  <react-component\r\n    class=\"AppNavigationLayout\"\r\n    name=\"AppNavigationAssetProjects\"\r\n    watch-depth=\"reference\">\r\n  </react-component>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/navigation/ngTemplates/app-navigation-asset-projects-list.html
// module id = 2281
// module chunks = 0